import React from "react";
import CarouselItem from "./../../molecules/carouselItem/index.jsx";
import "./styles.scss";

export default class Carousel extends React.Component {
  render() {
    const banner = this.props.banners?.length ? this.props.banners[Math.round(Math.random() * (this.props.banners.length - 1))] : undefined;

    return (
      <div className="carousel">
        <CarouselItem banner={banner} />

        <div className="carousel__message">
          <div className="container">
            <div className="message">
              <p className="b">
                <strong>Importante:</strong> Nuestros usados solo se venden a
                través de nuestro salón de ventas. No contamos con “vendedores
                externos”.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
